module.exports = __webpack_public_path__ + "static/img/img_boss.1e08479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/newvcr/img_boss.png
// module id = /fY8
// module chunks = 36